import React from 'react';
const intl = {
  headline: {
    'en': 'SERVICES',
    'dk': 'SERVICES',
  },
  block1: {
    headline: {
      'en': 'IT\'S ALL ABOUT... ',
      'dk': 'DET HELE HANDLER OM...',
    },
    subHeadline: {
      'en': 'Competitive advantage. We help our clients indentify, emphasize and develop their true uniqness.',
      'dk': 'Konkurrencemæssige fordele. Vi hjælper vores klienter med at identificere, fremhæve og udvikle deres enestående særkende. Det skaber reelle og blivende konkurrencemæssige fordele - det er vores mission.'
    },
    body: {
      'en': <div style={{ lineHeight: ' 16px', fontSize: '14px', color: '#8c8c8c' }}>
      iLEAD collects and analyzes data to gain an understanding of the organizations we work with. The data we collect helps us generate hypotheses, which we then test extensively for inconsistencies or inaccuracy.
      <br/><br/>
      Our insights are fed back to the organization in a variety of ways, informing decision-makers and form the basis of practical action plans for change. Our aim is to assist the organization as it defines and implements its own solutions.
      </div>,
      'dk': <div style={{ lineHeight: ' 16px', fontSize: '14px', color: '#8c8c8c' }}>
      iLEAD arbejder baseret på data og bruger alle de data indsamlingsmetoder der skaber mening i den organisatoriske sammenhæng. På den baggrund skaber vi hypoteser som vi tester for inkonsistens eller unøjagtigheder og på den baggrund skaber vi et meget nøjagtigt billede af hvad der er på spil i organisationen.
      <br/><br/>
      Denne indsigt bibringes organisationens aktører i forskellige fora og på forskellige måder således at organisationens ledelse opnår det bedst mulige beslutningsgrundlag for de tiltag der kræves i forbindelse med kontinuerlige forbedringer.
      </div>
    }
  },
  goToTestButton: {
    'en': 'GO TO TEST',
    'dk': 'GÅ TIL TEST',
  },
  divider1: {
    'en': 'WE WORK WITH THREE SPECIFIC AND VERY INTERLINKED AREA',
    'dk': 'VI ARBEJDER MED TRE SPECIFIKKE OG SAMMENHÆNGENDE OMRÅDER'
  },
  block2: {
    headline: {
      'en': 'LEADERSHIP EVALUATION TOOL',
      'dk': 'LEADERSKABS EVALUERINGS VÆRKTØJ',
    },
    body: {
      'en': <div>
        Leadership depends upon a wide range of dynamic relationships. In order to address them, a leader needs to be empathetic, present and focused.
        <br /><br />
        A results-oriented leader is one willing to take responsibility, motivate and inspire people. One who will stretch their colleagues but also give responsibility back to those who make change happen.
        <br /><br />
        Our Leadership Evaluation Tool helps you build awareness of how you lead. It examines key areas defined by 12 parameters. The findings are enhanced by input from three of the people you lead or have a professional work relation with.
        <br /><br />
        The use of Johari's window identifies what we know about ourselves and what we are blind to. Leadership Evaluation highlights the differences between how we perceive ourselves and how others experience us. The insights gained enable leaders to have more meaningful conversation with colleagues.
        <br /><br />
        Try it and let us know what you think. It's completely free of charge but not necessarily without personal cost. You might learn something important about yourself and your relationships. Enjoy.
      </div>,
      'dk': <div>
        Ledelse er karakteriseret af en lang række forhold. Forhold der hverken er eksklusive eller endegyldige i deres definition. De er kun indikerende for omfanget af lederens evne til at være empatisk, nærværende og fokuseret.
        <br /><br />
        Fokus bør være på skabelsen af resultater – en skabelse der afhænger af lederens evne til både at tage ansvar, motivere og inspirere mennesker; men også at stille krav og give noget af det ansvar fra sig.
        <br /><br />
        En selvevaluering er et værktøj, der giver dig mulighed for at vurdere dine leder evner defineret ved 12 parametre samlet under 3 overskrifter – og samtidig invitere tre andre til at give dig deres oplevelse af dig som leder.
        <br /><br />
        Johari‘s vindue beskriver blandt andet områder af os selv vi kender og områder vi er blinde for. Selvevalueringen åbner op for en beskrivelse af netop den forskel; hvordan vi oplever os selv – og hvordan andre oplever os. Resultatet giver os en mulighed for at indgå i en mere kvalificeret og målrettet dialog med kollegaer, medarbejdere eller ledere om hvad det er de ser.
        <br /><br />
        Prøv det og lad os høre hvad du synes. Det er gratis – men ikke nødvendigvis omkostningsfrit; du kunne blive rigere på vigtig viden om dig selv og dine relationer. God fornøjelse.
      </div>,
    },
  },
  block3: {
    headline1: {
      'en': 'CULTURE',
      'dk': 'KULTUR',
    },
    subheadline1: {
      'en': 'What is it and why is it so important?',
      'dk': 'Hvad er det og hvorfor er det så vigtigt?',
    },
    body1: {
      'en': 'We believe that with culture being so important and crucial in an organizations ability to perform it needs much more attention. It requires a continuous and conscious effort to develop a healthy well-functioning culture that support and enhance performance.',
      'dk': '',
    },
    headline2: {
      'en': 'COMMUNICATION',
      'dk': 'KOMMUNIKATION',
    },
    subheadline2: {
      'en': 'Build relations for collaborative results',
      'dk': 'Bygge relationer for fællers resultater',
    },
    body2: {
      'en': 'Communication has so many forms – especially with the explosion in digital formats. It is verbal and non-verbal. It tacit and implicit. It‘s obvious and hidden. Its conscious and subconscious or even unconscious. Whatever form it takes it creates and maintains relations between organizational members. In other words – its crucial to get right.',
      'dk': '',
    },
    headline3: {
      'en': 'CHANGE',
      'dk': 'FORANDRING',
    },
    subheadline3: {
      'en': 'Unavoidable and challenging. Why is it so hard?',
      'dk': 'Uundgåeligt og udfordrende. Hvorfor er det så svært?',
    },
    body3: {
      'en': 'We believe that with the right approach you can actually accelerate your change process – AND – get a better implementation result. It’s a myth that only 30% of change initiatives succeed.  iLEAD  have done some ground breaking research that allows for better and faster implementions.',
      'dk': 'Vi mener at forandringsprocesser faktisk kan implementeres hurtigere og mere effektivt - med den rette tilgang og forståelse - og med bedre resultat! Det er en myte at kun 30% af forandringsinitiativer lykkedes. iLead A/S har med sin forskning på området afdækket hvad der kræves for at skabe bedre forandringsresultater - hurtigere.',
    }
  },
  block4: {
    headline: {
      'en': <span>THE PIVOTAL POINT OF IT ALL - <b>LEADERSHIP</b></span>,
      'dk': <span>OMDREJNINGSPUNKTET FOR DET HELE - <b>LEDERSKABET</b></span>,
    },
    body: {
      'en': <div>
        <span style={{ color: '#1abc9c' }}>Executive coaching</span> Our approach to coaching is informed by the recognition that early developed patterns in behavior and our tendency to repeat behavior can trip us up. It‘s not only the behavior that works but also the ones that don’t we tend to repeat. Increased awareness and understanding enable leaders to change themselves or supplement their leadership team with the necessary complementary skills.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Supervision of leadership groups.</span> These groups usually consist of strong independent individuals that need to work together while having a high degree of autonomy in their own resort. These circumstances represent a multiple of potential strains within the system and opposed interests, which might cause unnecessary conflicts and tension.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Cultural advisory to Management / Board.</span> We help management and/or board in the role of cultural alignment advisors or even CCO (chief cultural officer) on a interim basis. It ensures the leadership team to have someone that actually focuses and address this crucial area especially in the volatile period of change.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Interim Solutions</span> We do also engage in interim assignments taking on the responsibility of leadership for a limited period of time. Terms and conditions are to be negotiated individually and customized to the organizations needs.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Leadership development programs.</span> Finally we offer bespoke leadership programs tailored to meet the organizational needs at any specific point in time with a clear view of future directions and goals. We work with a number of suppliers all over the world to ensure an suitable environment and conducive atmosphere for specifics goals.
        <br/><br/>All our services are tailored to our clients specific needs because every client is as stated - truly unique. Reach out and lets have a conversation about your challenges, goals and aspirations - and how we can help you.

      </div>,
      'dk': <div>
        <span style={{ color: '#1abc9c' }}>Executive coaching</span> Vores tilgang til coaching bygger på en erkendelse af, at tidligt udviklede mønstre kombineret med vores naturlige tendens til at gentage adfærd, kan spille os et puds. Det er ikke kun den adfærd der virker, men også den som ikke gør, vi har tendens til at gentage. En øget bevidsthed og forståelse gør det muligt for ledere, at ændre sig selv eller supplere deres ledelsesteam med de nødvendige komplementære færdigheder.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Supervision af ledergrupper.</span> Disse grupper består normalt af stærke uafhængige og selvstændige individer, der har brug for at arbejde sammen, mens de forsat bevarer en høj grad af autonomi på eget område. Disse betingelser manifesterer sig på forskellige måder i systemet . Det kan fx være modsatrettede interesser, jalousi over ressource fordeling, usund konkurrence etc. hvilket kan forårsage unødvendige konflikter og spændinger.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Kulturel rådgiver.</span> Vi hjælper ledelse og/eller bestyrelse i rollen som kulturrådgiver eller endog CCO (chief culturel officer) på interim basis. Det sikrer, at ledelsesteamet har nogen, der rent faktisk fokuserer og tager fat på dette afgørende område, især i en periode med forandringer.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Interim løsninger</span> Vi påtager os lighedsvis det ledelsesmæssige ansvar i en begrænset periode. Vilkår og betingelser forhandles individuelt og er afstemt efter organisationens behov.
        <br/><br/>
        <span style={{ color: '#1abc9c' }}>Lederudviklings forløb.</span> Endelig tilbyder vi lederudviklingsprogrammer, der er skræddersyet til at opfylde de organisatoriske behov på et hvilket som helst bestemt tidspunkt med et klart overblik over fremtidige retninger og mål.
        <br/><br/>Vi arbejder med en række leverandører over hele verden for at sikre et passende miljø og befordrende atmosfære for specifikke formål fx i Sydafrika.

      </div>,
    },
    buttonTxt: {
      en:'Test my leadership',
      dk: 'Test mit lederskab',
    }
  },
  block5: {
    subheadline: {
      'en': 'LIFE IS ABOUT OPPORTUNITIES',
      'dk': 'LIVET HANDLER OM MULIGHEDER'
    },
    headline: {
      'en': <span>The opportunities around us are infinite. If only we dare to look for them, and have courage to do what it takes, whether it's change of direction, structure or event strategy. <br/><br/>
      Well, sometimes it's just ourselves we need to change!</span>,
      'dk': <span>Mulighederne omkring os er uendelige. Hvis vi tør kigge op og har modet til gøre det, der kræves. Uanset om det er at ændre retning, struktur – eller strategi! <br/><br/> og nogle gange er det 'bare' os selv der skal turde forandring!</span>
    }
  }
}

export default intl;



// WEBPACK FOOTER //
// ./src/pages/Services/intl.js